import { dispatch } from '@rematch/core';
import { push } from "react-router-redux";
import {
    templatesService,
    subOrganizationTreeService,
    tagsTreeService,
    usersPermissionsService,
    dashboardsService,
    accountUsersService,
    dashboardUsersService,
    dashboardEventsService,
    dashboardConceptsService
} from '../../services/feathers.service';

const initialState = {
    resourcePaneFlag: null,
    arrangementPaneFlag: null,
    isNameAvailable: true,
    publishedTemplates: [],
    selectedDashboard: {},
    myDashboards: {},
    authorizedUsers: [],
    selectedTemplate: {},
    conceptDetails: {},
    initiativeDetails: {},
    eventDetails: {},
    groupDetails: {},
    concepts: [],
    groups: [],
    events: [{},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {}],
    allUsers: [],
    splitAtSize: null,
};



export default {
    state: initialState,
    reducers: {
        showResourecePaneFlagSet(state, payload) {
            return {
                ...state,
                resourcePaneFlag: payload
            }
        },
        showArrangementPaneFlagSet(state, payload) {
            return {
                ...state,
                arrangementPaneFlag: payload
            }
        },
        setNameAvailabilityFlag(state, payload) {
            return {
                ...state,
                isNameAvailable: payload
            }
        },
        setTemplatesArray(state, payload) {
            return {
                ...state,
                publishedTemplates: payload
            }
        },
        setSelectedDashboard(state, payload) {
            return {
                ...state,
                selectedDashboard: payload
            }
        },
        setMyDashboardList(state, payload) {
            return {
                ...state,
                myDashboards: payload
            }
        },
        setAuthorizedUsers(state, payload) {
            return {
                ...state,
                authorizedUsers: payload
            }
        },
        setSelectedTemplate(state, payload) {
            return {
                ...state,
                selectedTemplate: payload
            }
        },
        setDashboardConceptDetails(state, payload) {
            return {
                ...state,
                conceptDetails: payload
            }
        },
        setDashboardInitiativeDetails(state, payload) {
            return {
                ...state,
                initiativeDetails: payload
            }
        },
        setDashboardEventDetails(state, payload) {
            return {
                ...state,
                eventDetails: payload
            }
        },
        setDashboardGroupDetails(state, payload) {
            return {
                ...state,
                groupDetails: payload
            }
        },
        setConceptsData(state, payload) {
            return {
                ...state,
                concepts: payload
            }
        },
        setGroupData(state, payload) {
            return {
                ...state,
                groups: payload
            }
        },
        setEventsData(state, payload) {
            return {
                ...state,
                events: payload
            }
        },
        allUserList(state, payload) {
            return {
                ...state,
                allUsers: payload
            }
        },
        setSplitAtSize(state, payload) {
            return {
                ...state,
                splitAtSize: payload
            }
        },
    },
    effects: {
        openResourcePane(payload) {
            try {
                dispatch.dashboards.showResourecePaneFlagSet(payload);
                return;
            } catch (e) {
                throw e;
            }
        },
        arrangementPaneFlag(payload) {
            try {
                dispatch.dashboards.showArrangementPaneFlagSet(payload);
                return;
            } catch (e) {
                throw e;
            }
        },
        async getPublishedTemplates(payload) {
            try {
                let query = {
                    status: 1,
                    $limit: payload.limit,
                }
                let publishedTemplates = await templatesService.find({ query: query });
                dispatch.dashboards.setTemplatesArray(publishedTemplates);
            } catch (e) {
                throw e;
            }
        },
        async getDashboardById(payload) {

            try {
                let dashboard = await dashboardsService.get(payload, {
                    query: {
                        $populate: [
                            { path: 'teams', populate: 'teams', select: '_id name description' },
                            { path: 'tags', populate: 'tags', select: '_id name description' },
                            { path: 'createdBy', populate: 'createdBy', select: '_id firstName lastName profilePic' },
                            { path: 'contributors.accountUserId', populate: 'accountUserId', select: '_id firstName lastName profilePic email' },
                            { path: 'events', populate: 'events' },
                            { path: 'concepts', populate: 'concepts' }
                        ]
                    }
                });

                dispatch.dashboards.setSelectedDashboard(dashboard)
            } catch (e) {
                throw e;
            }
        },
        async getTemplateById(payload) {
            try {
                let templateData = await templatesService.get(payload, {
                    query: {
                        $populate: [
                            { path: 'teams', populate: 'teams', select: '_id name description' },
                            { path: 'tags', populate: 'tags', select: '_id name description' }
                        ]
                    }
                });
                dispatch.dashboards.setSelectedTemplate(templateData);
            } catch (e) {
                throw e;
            }
        },
        async createDashboard(payload, state) {
            try {
                let result = await dashboardsService.create(payload);
                dispatch.dashboards.setSelectedDashboard(result)
                return dispatch(push(`/app/${state.app.selectedAccount._id}/_ws/${state.app.selectedOrganisation.id}/_dc/create/step2/${result._id}`));
            } catch (e) {
                throw e;
            }
        },
        async getAuthorizedUsersForDashboardCreation(payload) {
            /** this function will return the users who have permission of dashboard creation
             * payload should contain,
             * searchParams: string to be searhed as username or email
             * contributors: existing contributors id array so that it can exclude them while getting new ones
             */
            try {
                let data;
                if (payload && payload.searchParam) {
                    data = await usersPermissionsService.find({ query: { permission: "dashboardCreation", queryParam: payload.searchParam, contributors: payload.contributors } });
                }
                else {
                    data = await usersPermissionsService.find({ query: { permission: "dashboardCreation", contributors: payload.contributors } });
                }
                dispatch.dashboards.setAuthorizedUsers(data);
            } catch (e) {
                throw e;
            }


        },
        async getMyDashboards(payload) {
            try {
                let query = {
                    $limit: payload.limit,
                }
                let myDashboards = await dashboardsService.find({ query: query });
                dispatch.dashboards.setMyDashboardList(myDashboards);
            } catch (e) {
                throw e;
            }
        },
        async updateDashboard(payload, state) {
            try {
                await dashboardsService.patch(payload._id, payload.data);

                if (payload.data.status === 1) {
                    return dispatch(push(`/app/${state.app.selectedAccount._id}/_ws/${state.app.selectedOrganisation.id}/_dc/view/${payload._id}`));
                }
                else if (state.dashboards.selectedDashboard.status === 0) {
                    return dispatch(push(`/app/${state.app.selectedAccount._id}/_ws/${state.app.selectedOrganisation.id}/_dc/create/step2/${payload._id}`));
                }
            } catch (e) {
                throw e;
            }
        },
        async dashboardConceptDetail(payload, state) {
            try {
                dispatch.dashboards.setDashboardConceptDetails(payload);
            } catch (e) {
                throw e;
            }
        },
        async dashboardIniatativeDetail(payload, state) {
            try {
                dispatch.dashboards.setDashboardInitiativeDetails(payload);
            } catch (e) {
                throw e;
            }
        },
        async dashboardEventDetail(payload, state) {
            try {
                dispatch.dashboards.setDashboardEventDetails(payload);
            } catch (e) {
                throw e;
            }
        },
        async dashboardGroupDetail(payload, state) {
            try {
                dispatch.dashboards.setDashboardGroupDetails(payload);
            } catch (e) {
                throw e;
            }
        },
        async getAllAccountUsers(payload, state) {
            try {
                let p = {
                    query: payload.query
                }
                let allUsers = await accountUsersService.find(p);
                dispatch.dashboards.allUserList(allUsers);
            } catch (e) {
                throw e;
            }
        },
        async getUsersByTemplateId(payload) { // send Id of the template 

            try {
                let query = {
                    templateId: payload.templateId,
                    query: payload.query,
                }
                let usersData = await dashboardUsersService.find({ query: query });
                dispatch.dashboards.allUserList(usersData);

            } catch (e) {
                throw e;
            }


        },
        splitAt(payload) {
            dispatch.dashboards.setSplitAtSize(payload)
        },
        async addGroup(payload) {
            await dashboardsService.patch(payload.id, { "$push": { groups: payload.data } });
        },
        async createEvent(payload) {
            await dashboardEventsService.create(payload);
        },
        async createConcept(payload) {
            await dashboardConceptsService.create(payload)
        },
        addConceptInDashboard(payload, state) {
            let dashboard = Object.assign({}, state.dashboards.selectedDashboard);
            if (dashboard && dashboard._id && dashboard._id.toString() === payload.dashboardId.toString()) {
                if (!dashboard.concepts) {
                    dashboard.concepts = [];
                }
                dashboard.concepts.push(payload);
                dispatch.dashboards.setSelectedDashboard(Object.assign({}, dashboard, { concepts: dashboard.concepts }))
            }
        },
        addEventInDashboard(payload, state) {
            let dashboard = Object.assign({}, state.dashboards.selectedDashboard);
            if (dashboard && dashboard._id && dashboard._id.toString() === payload.dashboardId.toString()) {
                if (!dashboard.events) {
                    dashboard.events = [];
                }
                dashboard.events.push(payload);
                dispatch.dashboards.setSelectedDashboard(Object.assign({}, dashboard))
            }
        },
        updateSelectedDashboard(payload, state) {
            let dashboard = Object.assign({}, state.dashboards.selectedDashboard);
            if (dashboard && dashboard._id && dashboard._id.toString() === payload._id.toString()) {
                let newDashboard = Object.assign({}, dashboard, payload)
                dispatch.dashboards.setSelectedDashboard(Object.assign({}, newDashboard))
            }
        },
        async updateEvent(payload) {
            await dashboardEventsService.patch(payload._id, payload.data);
        },
        async updateGroupInDashboard(payload) {
            await dashboardsService.patch(null, payload.data, {
                query: {
                    _id: payload._id,
                    "groups._id": payload.query.groupId
                }
            });
        },
        async updateConcept(payload) {
            try {
                await dashboardConceptsService.patch(payload._id, payload.data);
            }
            catch (e) {
                throw e;
            }

        },
        async updateInitiativeInConcept(payload) {
            await dashboardConceptsService.patch(null, payload.data, {
                query: {
                    _id: payload._id,
                    "initiatives._id": payload.query.initiativeId
                }
            });
        },
        updateConceptInDashboard(payload, state) {
            let dashboard = Object.assign({}, state.dashboards.selectedDashboard);
            if (dashboard && dashboard._id && dashboard._id.toString() === payload.dashboardId.toString()) {
                let newConcepts = dashboard.concepts;
                newConcepts.forEach((concept, index) => {
                    if (concept._id.toString() === payload._id.toString()) {
                        newConcepts[index] = payload;
                    }
                })
                dispatch.dashboards.setSelectedDashboard(Object.assign({}, dashboard, { concepts: newConcepts }))
            }

        },
        dndInitiative(payload) {
            dashboardConceptsService.patch(payload.from, { initiatives: payload.fromArray });
            dashboardConceptsService.patch(payload.to, { initiatives: payload.toArray });
        },
        removeGroup(payload) {
            dashboardsService.patch(payload._id, { $pull: { groups: { _id: payload.groupId } } })
        },
        removeEvent(payload) {
            dashboardEventsService.remove(payload)
        },
        removeEventFromDashboard(payload, state) {
            let dashboard = Object.assign({}, state.dashboards.selectedDashboard);

            if (dashboard && dashboard._id && dashboard._id.toString() === payload.dashboardId.toString()) {
                let newEvents = dashboard.events.filter(event => { return event._id.toString() !== payload._id.toString() })
                dispatch.dashboards.setSelectedDashboard(Object.assign({}, dashboard, { events: newEvents }))
            }
        },
        removeConcept(payload) {
            dashboardConceptsService.remove(payload)
        },
        removeConceptFromDashboard(payload, state) {
            let dashboard = Object.assign({}, state.dashboards.selectedDashboard);

            if (dashboard && dashboard._id && dashboard._id.toString() === payload.dashboardId.toString()) {
                let newConcepts = dashboard.concepts.filter(event => { return event._id.toString() !== payload._id.toString() })
                dispatch.dashboards.setSelectedDashboard(Object.assign({}, dashboard, { concepts: newConcepts }))
            }
        }
    }
}